import {
  EmailFieldRHF,
  EnhancedDropDownRHFWithLabel,
  IEnhancedDropDownItem,
  ITest,
  LabelPosition,
  PostCodeRHF,
  RHookFormTextFieldWithLabel,
} from "@websential/cosmic";
import { FC, useState } from "react";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";

import { Box } from "@mui/material";
import { IProvinceReferenceModel } from "../../../../models/province/IProvinceReferenceModel";
import { ProvinceService } from "../../../../services/common/ProvinceService";
import { useQuery } from "@tanstack/react-query";

interface IEmployeeAddressSetupFieldsPanel extends ITest { }
export let provinceResponce: any = undefined;
export const EmployeeAddressSetupFieldsPanel: FC<IEmployeeAddressSetupFieldsPanel> =
  ({ testId }) => {
    // const [selectedProvince, setSelectedProvince] =
    //   useState<IProvinceReferenceModel>({
    //     id: null,
    //     name: "",
    //     shortCode: "",
    //   });
    const useGetProvinceDDL = () => {
      return useQuery({
        queryKey: [GET_QUERY_KEY.PROVINCE_DDL],
        queryFn: () => ProvinceService.get(),
        ...QUERY_OPTIONS,
      });
    };
    const { isPending: isLoadingProvinceDropDownList, data: provinceList } =
      useGetProvinceDDL();
    // const onProvinceSelectionChangeHandler = (item: IEnhancedDropDownItem) => {
    //   setSelectedProvince({
    //     id: item.id,
    //     name: item.label,
    //     shortCode: String(item.value),
    //   });
    // };
    // provinceResponce = selectedProvince;
    return (
      <>
        <RHookFormTextFieldWithLabel
          label="Address"
          id="addressLine1"
          testId={`${testId}-employee-address`}
          labelPosition={LabelPosition.Left}
          required
        />
        <RHookFormTextFieldWithLabel
          label="City"
          id="city"
          testId={`${testId}-employee-city`}
          labelPosition={LabelPosition.Left}
          required
        />
        {/* <RHookFormTextFieldWithLabel
          label="Province"
          id="province"
          testId={`${testId}-employee-province`}
          labelPosition={LabelPosition.Left}
          required
        /> */}
        <EnhancedDropDownRHFWithLabel
          selectName="province"
          label="Province"
          // selectedItem={selectedProvince.id !== null && selectedProvince}
          labelPosition={LabelPosition.Left}
          required
          testId={`${testId}-province-list`}
          items={provinceList ?? []}
        // onSelectionChangeHandler={onProvinceSelectionChangeHandler}
        />
        <PostCodeRHF
          label="Post Code"
          id="postalCode"
          testId={`${testId}-employee-post-code`}
          labelPosition={LabelPosition.Left}
          labelColumns={4}
          fieldColumns={8}
          required
        />
        <RHookFormTextFieldWithLabel
          label="Country"
          id="country"
          testId={`${testId}-employee-country`}
          labelPosition={LabelPosition.Left}
          value="Canada"
          defaultValue={"Canada"}
          readOnly
          required
        />
        <EmailFieldRHF
          label="Email"
          id="email"
          testId={`${testId}-employee-email`}
          labelPosition={LabelPosition.Left}
          labelColumns={4}
          fieldColumns={8}
        />
      </>
    );
  };
